import React from "react";
import Image from "../../assets/images/404.png"

const NotFound:React.FC = () => {
    return(
        <div className={"w-screen bg-white mx-auto grid h-screen place-items-center"}>
            <div>
                <img src={Image} alt={"not_found"}/>
            </div>
        </div>
    )
}

export default NotFound